/* SES Palma · portal · herramientas puras de la recepción (sin DOM): las usa ses-b2b-fulfil.js y se
   prueban en Node (scripts/test-rcv-tools.mjs).
   - ScanBurst: distingue una pistola lectora (teclado muy rápido + Enter/Tab) de una persona tecleando.
   - parseVoice: interpreta una frase dictada («Anna natural talla M tres», «dos Miquel nit L») contra las
     líneas de ESTE envío (estilo, color, talla y cantidad en es/en/fr/it). Nunca inventa: si no hay una
     línea clara devuelve ok=false con las candidatas. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SESRcvTools = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /* ---------- lector de códigos ---------- */
  // Una ráfaga es lector si tiene >= minLen caracteres, cada uno a < maxGap ms del anterior y termina en
  // Enter o Tab. Una pausa > resetGap empieza una ráfaga nueva (lo anterior era una persona tecleando).
  function ScanBurst(opts) {
    const o = opts || {};
    this.minLen = o.minLen || 6;
    this.maxGap = o.maxGap || 50;
    this.resetGap = o.resetGap || 150;
    this.reset();
  }
  ScanBurst.prototype.reset = function () { this.buf = ''; this.last = 0; this.slow = false; };
  // key: KeyboardEvent.key; t: ms. Devuelve {type:'char'} | {type:'scan', code} | {type:'enter', code, manual:true} | null
  ScanBurst.prototype.feed = function (key, t) {
    if (key === 'Enter' || key === 'Tab') {
      const code = this.buf;
      const fast = code.length >= this.minLen && !this.slow;
      this.reset();
      if (!code) return null;
      return fast ? { type: 'scan', code } : { type: 'enter', code, manual: true };
    }
    if (typeof key !== 'string' || key.length !== 1) return null;
    if (this.buf && t - this.last > this.resetGap) this.reset();
    if (this.buf && t - this.last > this.maxGap) this.slow = true;
    this.buf += key;
    this.last = t;
    return { type: 'char' };
  };
  // ¿Va a ser lector? (para no dejar que la ráfaga caiga en un campo de texto)
  ScanBurst.prototype.looksLikeScan = function () { return this.buf.length >= 3 && !this.slow; };

  // EAN-8/EAN-13 con dígito de control correcto
  function validEan(code) {
    const s = String(code || '');
    if (!/^\d{8}$|^\d{13}$/.test(s)) return false;
    const d = s.split('').map(Number);
    const check = d.pop();
    const sum = d.reverse().reduce((a, n, i) => a + n * (i % 2 === 0 ? 3 : 1), 0);
    return (10 - (sum % 10)) % 10 === check;
  }

  /* ---------- voz ---------- */
  const fold = (v) => String(v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  function tokens(text) {
    return fold(text).replace(/[’']/g, ' ').replace(/(\d)([a-z])/g, '$1 $2').replace(/([a-z])(\d)/g, '$1 $2')
      .replace(/[^a-z0-9/]+/g, ' ').trim().split(/\s+/).filter(Boolean);
  }

  const UNITS = {
    es: ['cero', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve', 'diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciseis', 'diecisiete', 'dieciocho', 'diecinueve', 'veinte', 'veintiuno', 'veintidos', 'veintitres', 'veinticuatro', 'veinticinco', 'veintiseis', 'veintisiete', 'veintiocho', 'veintinueve'],
    en: ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty'],
    fr: ['zero', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf', 'dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf', 'vingt'],
    it: ['zero', 'uno', 'due', 'tre', 'quattro', 'cinque', 'sei', 'sette', 'otto', 'nove', 'dieci', 'undici', 'dodici', 'tredici', 'quattordici', 'quindici', 'sedici', 'diciassette', 'diciotto', 'diciannove', 'venti'],
  };
  const TENS = {
    es: { treinta: 30, cuarenta: 40, cincuenta: 50, sesenta: 60, setenta: 70, ochenta: 80, noventa: 90, cien: 100 },
    en: { thirty: 30, forty: 40, fifty: 50, sixty: 60, seventy: 70, eighty: 80, ninety: 90, hundred: 100 },
    fr: { trente: 30, quarante: 40, cinquante: 50, soixante: 60, cent: 100 },
    it: { trenta: 30, quaranta: 40, cinquanta: 50, sessanta: 60, settanta: 70, ottanta: 80, novanta: 90, cento: 100 },
  };
  const NUM = new Map();
  Object.keys(UNITS).forEach((l) => UNITS[l].forEach((w, i) => { if (!NUM.has(w)) NUM.set(w, i); }));
  Object.keys(TENS).forEach((l) => Object.keys(TENS[l]).forEach((w) => NUM.set(w, TENS[l][w])));
  ['una', 'un', 'une', 'uno'].forEach((w) => NUM.set(w, 1));
  NUM.set('veintiun', 21); NUM.set('dix', 10); NUM.set('seize', 16);
  const NUM_JOIN = new Set(['y', 'and', 'et', 'e']);
  // palabras que no aportan (artículos, «talla», «unidades», «de»)
  const FILLER = new Set(['talla', 'size', 'taille', 'taglia', 'de', 'del', 'la', 'el', 'los', 'las', 'of', 'the', 'du', 'des', 'le', 'les', 'di', 'il', 'lo',
    'unidades', 'unidad', 'uds', 'ud', 'units', 'unit', 'pcs', 'pieces', 'piezas', 'pezzi', 'pezzo', 'piece', 'en', 'in', 'color', 'colour', 'couleur', 'colore', 'x', 'por', 'pour', 'per', 'son', 'sont', 'are', 'hay', 'llegaron', 'recibidas', 'recibido', 'received']);

  // tallas habladas → código de talla
  const SIZE_WORDS = {
    xs: 'XS', s: 'S', m: 'M', l: 'L', xl: 'XL', xxl: 'XXL', u: 'U', unica: 'U', unique: 'U',
    ese: 'S', eme: 'M', ele: 'L', equis: 'X', ex: 'X', small: 'S', medium: 'M', large: 'L', petite: 'S', moyenne: 'M', grande: 'L', piccola: 'S', media: 'M', esse: 'S', emme: 'M', elle: 'L',
  };
  function normSize(s) { return fold(s).replace(/\s+/g, '').toUpperCase(); }

  function lev(a, b) {
    if (a === b) return 0;
    const m = a.length, n = b.length;
    if (!m || !n) return m || n;
    let prev = Array.from({ length: n + 1 }, (_, i) => i);
    for (let i = 1; i <= m; i++) {
      const cur = [i];
      for (let j = 1; j <= n; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = cur;
    }
    return prev[n];
  }
  // ¿encaja la secuencia de palabras «phrase» empezando en toks[i]? (tolera 1 error en palabras de 4+ letras)
  function matchAt(toks, i, phrase) {
    for (let k = 0; k < phrase.length; k++) {
      const a = toks[i + k], b = phrase[k];
      if (a == null) return false;
      if (a === b) continue;
      if (b.length >= 4 && lev(a, b) <= (b.length >= 7 ? 2 : 1)) continue;
      return false;
    }
    return true;
  }

  // Extrae cantidad y talla de los tokens libres. Devuelve {qty, size, rest:[tokens sin usar]}
  function numbersAndSize(toks, sizes) {
    const used = new Array(toks.length).fill(false);
    let size = null;
    // 1) talla: códigos de talla de este envío, incluidos compuestos (S/M, «s m», «ese barra eme», «equis ele»)
    const sizeCodes = [...new Set(sizes.map(normSize))].sort((a, b) => b.length - a.length);
    for (let i = 0; i < toks.length && !size; i++) {
      // ventana de hasta 4 tokens convertidos a letras de talla; gana la coincidencia más larga
      let acc = '', best = null;
      for (let k = 0; k < 4 && i + k < toks.length; k++) {
        const tk = toks[i + k];
        if (tk === 'barra' || tk === 'slash' || tk === '/') { acc += '/'; continue; }
        const w = tk.includes('/') ? tk.toUpperCase() : (SIZE_WORDS[tk] !== undefined ? SIZE_WORDS[tk] : (tk.length <= 3 && /^[xsml]+$/.test(tk) ? tk.toUpperCase() : null));
        if (!w) break;
        acc += w;
        const hit = sizeCodes.find((c) => c === acc || c.replace('/', '') === acc.replace(/\//g, ''));
        if (hit) best = { hit, end: i + k };
      }
      if (best) {
        size = best.hit;
        for (let z = i; z <= best.end; z++) used[z] = true;
      }
    }
    // 2) cantidad: cifra o número en palabras («treinta y dos»)
    let qty = null;
    for (let i = 0; i < toks.length && qty == null; i++) {
      if (used[i]) continue;
      const tk = toks[i];
      if (/^\d{1,4}$/.test(tk)) { qty = Number(tk); used[i] = true; break; }
      if (NUM.has(tk)) {
        // «una»/«un» delante de una palabra que no es número puede ser artículo: solo vale si está sola al final o al principio
        let v = NUM.get(tk);
        used[i] = true;
        if (v >= 20 && NUM_JOIN.has(toks[i + 1]) && NUM.has(toks[i + 2]) && NUM.get(toks[i + 2]) < 10) { v += NUM.get(toks[i + 2]); used[i + 1] = used[i + 2] = true; }
        else if (v >= 20 && NUM.has(toks[i + 1]) && NUM.get(toks[i + 1]) < 10) { v += NUM.get(toks[i + 1]); used[i + 1] = true; }
        qty = v;
      }
    }
    return { qty, size, rest: toks.filter((_, i) => !used[i] && !FILLER.has(toks[i])) };
  }

  // lines: [{sku, name, color, size}]. Devuelve
  //  { ok, line, qty, mode, understood:{name,color,size,qty}, candidates:[line], transcript }
  //  mode: 'add' | 'replace' si la frase lo dice («más», «en plus», «in più» / «son», «en total», «=»); si no, null
  function parseVoice(text, lines) {
    const cue = modeCue(tokens(text), /=/.test(String(text || '')));
    const toks = cue.toks;
    const out = { ok: false, line: null, qty: null, mode: cue.mode, understood: { name: null, color: null, size: null, qty: null }, candidates: [], transcript: String(text || '') };
    if (!toks.length || !lines || !lines.length) return out;
    const ns = numbersAndSize(toks, lines.map((l) => l.size).filter(Boolean));
    out.understood.size = ns.size;
    out.understood.qty = ns.qty;
    const rest = ns.rest;
    // estilo y luego color, por coincidencia de palabras (tolerante a erratas del reconocedor)
    const find = (names, toksIn) => {
      let best = null;
      names.forEach((n) => {
        const ph = tokens(n);
        if (!ph.length) return;
        for (let i = 0; i + ph.length <= toksIn.length; i++) {
          if (!matchAt(toksIn, i, ph)) continue;
          const score = ph.join('').length;
          if (!best || score > best.score) best = { name: n, score, at: i, len: ph.length };
        }
      });
      return best;
    };
    const st = find([...new Set(lines.map((l) => l.name))], rest);
    const afterStyle = st ? rest.filter((_, i) => i < st.at || i >= st.at + st.len) : rest;
    const linesForColor = st ? lines.filter((l) => l.name === st.name) : lines;
    const coIn = find([...new Set(linesForColor.map((l) => l.color).filter(Boolean))], afterStyle);
    out.understood.name = st ? st.name : null;
    out.understood.color = coIn ? coIn.name : null;
    let cands = lines.filter((l) =>
      (!st || l.name === st.name) &&
      (!coIn || l.color === coIn.name) &&
      (!ns.size || normSize(l.size) === ns.size));
    if (!st && !coIn) cands = [];
    out.candidates = cands;
    if (cands.length === 1 && (st || coIn)) {
      out.ok = true;
      out.line = cands[0];
      out.qty = ns.qty == null ? 1 : ns.qty;
      out.understood.qty = out.qty;
    }
    return out;
  }

  // Palabras que deciden si la cantidad se suma o sustituye; se quitan de la frase
  const CUE_ADD = [['en', 'plus'], ['in', 'piu'], ['de', 'mas'], ['mas'], ['plus'], ['piu'], ['more'], ['extra'], ['add'], ['anade'], ['suma'], ['sumar'], ['ajoute'], ['ajouter'], ['aggiungi']];
  const CUE_SET = [['en', 'total'], ['in', 'totale'], ['in', 'total'], ['total'], ['totale'], ['son'], ['sont'], ['sono'], ['are'], ['igual', 'a'], ['equals']];
  function modeCue(toks, hasEquals) {
    let mode = hasEquals ? 'replace' : null;
    const out = toks.slice();
    const strip = (list, m) => {
      list.slice().sort((a, b) => b.length - a.length).forEach((ph) => {
        for (let i = 0; i + ph.length <= out.length; i++) {
          if (ph.every((w, k) => out[i + k] === w)) { out.splice(i, ph.length); if (!mode) mode = m; i--; }
        }
      });
    };
    strip(CUE_SET, 'replace');
    strip(CUE_ADD, 'add');
    return { mode, toks: out };
  }

  // Idioma del reconocedor según el idioma del portal
  const SPEECH_LANG = { es: 'es-ES', en: 'en-GB', fr: 'fr-FR', it: 'it-IT' };

  return { ScanBurst, validEan, parseVoice, tokens, SPEECH_LANG };
});
